import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import CompetenciesServices from "./competencies.services";
import GestorDocumentalServices from "../../gestorDocumental/gestorDocumental.services";

export const getCompetencies = filters => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_COMPETENCIES,
      payload: true,
    });
    const resp = await CompetenciesServices.getCompetencies(filters);
    dispatch({
      type: actions.GET_COMPETENCIES,
      payload: resp.data,
    });
    dispatch({
      type: actions.COMPETENCIES_FAIL,
      payload: null,
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: null,
    });
    // toastr.success(messages.successMessage, '', {
    //   progressBar: true,
    //   rtl: true,
    // });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      }else{
        message = messages.networkError;
      }
    }else{
      message = messages.applicationError
    }
    dispatch({
      type: actions.COMPETENCIES_FAIL,
      payload: message
    })
  }finally {
    dispatch({
      type: actions.LOADING_COMPETENCIES,
      payload: false,
    });
  }
}

export const getCompetenciesXCompetencieType = (filters,setLoader,setcompetenciaTemp,setcompetenciaTempCount,setNumCompetencias,setcompetenciaTempError,setFirstLoad) => async (dispatch) => {
  try {
    setLoader(true);
    const resp = await CompetenciesServices.getCompetencies(filters);
    setcompetenciaTemp(resp.data.data);
    setcompetenciaTempCount(resp.data.count);
    setNumCompetencias(resp.data.conteo_nivel_desarrollo)
    setFirstLoad(true)
    setcompetenciaTempError("");
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      }else{
        message = messages.networkError;
      }
    }else{
      message = messages.applicationError
    }
    setcompetenciaTempError(message);
  }finally {
    setLoader(false);
  }
}

export const getCompetencie = id => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_COMPETENCIE,
      payload: true,
    });
    const resp = await CompetenciesServices.getCompetencie(id);
    dispatch({
      type: actions.GET_COMPETENCIE,
      payload: resp.data,
    });
    dispatch({
      type: actions.COMPETENCIE_FAIL,
      payload: null,
    });
    // toastr.success(messages.successMessage, '', {
    //   progressBar: true,
    //   rtl: true,
    // });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            message = messages.notFound;
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      }else{
        message = messages.networkError;
      }
    }else{
      message = messages.applicationError
    }
    dispatch({
      type: actions.COMPETENCIE_FAIL,
      payload: message
    })
  }finally {
    dispatch({
      type: actions.LOADING_COMPETENCIE,
      payload: false,
    });
  }
}

export const saveCompetencie = (data, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADING_COMPETENCIES,
      payload: true,
    });
    // debugger;
    // const {req} = data;
    // const repGD = await GestorDocumentalServices.saveCompetenciesDocument(reqDoc);
    // req.archivo = repGD.data.resultado.id;
    const resp = await CompetenciesServices.saveCompetencie(data);
    const { competencies } = getState().competencies;
    dispatch({
      type: actions.GET_COMPETENCIES,
      payload: {
        count: competencies.count + 1,
        data: [...competencies.data, resp.data]
      },
    });

    dispatch({
      type: actions.FORM_FAIL,
      payload: null,
    });

    toastr.success(messages.successMessage, '', {
      progressBar: true,
      rtl: true,
    });

    setShowModal(false);

  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data;
            break;
          case 404:
            if(ex.response.data && ex.response.data.mensaje){
              message = ex.response.data.mensaje;
            }else if (ex.response.data && ex.response.data.resultado && ex.response.data.resultado[0].response){
              message = ex.response.data.resultado[0].response;
            }else{
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      }else{
        message = messages.networkError;
      }
    }else{
      message = messages.applicationError
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message
    })
  }finally {
    dispatch({
      type: actions.SAVE_LOADING_COMPETENCIES,
      payload: false,
    });
  }
}

export const editCompetencie = (id, data, index, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADING_COMPETENCIES,
      payload: true,
    });
    // const {req, reqDoc} = data;
    // if (reqDoc){
    //   await GestorDocumentalServices.editCompetenciesDocument(reqDoc.id, reqDoc);
    // }
    const resp = await CompetenciesServices.editCompetencie(id, data);
    // debugger;
    const { competencies } = getState().competencies;
    let _competencies = competencies.data.slice();
    _competencies[index] = resp.data;
    dispatch({
      type: actions.GET_COMPETENCIES,
      payload: {
        count: competencies.count,
        data: _competencies
      },
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: null,
    });
    toastr.success(messages.successMessage, '', {
      progressBar: true,
      rtl: true,
    });
    setShowModal(false);

  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data;
            break;
          case 404:
            if(ex.response.data && ex.response.data.mensaje){
              message = ex.response.data.mensaje;
            }else{
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      }else{
        message = messages.networkError;
      }
    }else{
      message = messages.applicationError
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message
    })
  }finally {
    dispatch({
      type: actions.SAVE_LOADING_COMPETENCIES,
      payload: false,
    });
  }
}

export const editCompetencieXCompetencieType = (id,data) => async (dispatch, getState) => {
  try {
    // setLoader(true)
    // const _competenciaTemp = competenciaTemp;
    await CompetenciesServices.editCompetencieXCompetencieType(id, data);
    // _competenciaTemp[index] = resp.data;
    // setcompetenciaTemp(competenciaTemp)
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data;
            break;
          case 404:
            if(ex.response.data && ex.response.data.mensaje){
              message = ex.response.data.mensaje;
            }else{
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      }else{
        message = messages.networkError;
      }
    }else{
      message = messages.applicationError
    }
    toastr.error(message, '', {
      progressBar: true,
      rtl: true,
    });
  }finally {
    // setLoader(false)
  }
}

export const deleteCompetencie = (id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_COMPETENCIES,
      payload: true,
    });
    await CompetenciesServices.deleteCompetencie(id);
    const { competencies } = getState().competencies;
    let _competencies = competencies.data.slice();
    _competencies.splice(index, 1);
    dispatch({
      type: actions.GET_COMPETENCIES,
      payload: {
        data: _competencies,
        count: competencies.count - 1
      }
    });
    dispatch({
      type: actions.COMPETENCIES_FAIL,
      payload: null,
    });
    toastr.success(messages.successMessage, '', {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            message = messages.notFound;
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      }else{
        message = messages.networkError;
      }
    }else{
      message = messages.applicationError
    }
    dispatch({
      type: actions.COMPETENCIES_FAIL,
      payload: message
    })
  }finally {
    dispatch({
      type: actions.LOADING_COMPETENCIES,
      payload: false,
    });
  }
}